import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Sidebar from "../../../partials/aside/Sidebar";
import httpService from "../../../../services/httpServices/httpServices";
import helperSpinner from "../../../../helpers/spinner";
import helperNumber from "../../../../helpers/numbers";
import helperTime from "../../../../helpers/time";
import TypeGroupSitePublisher from "./../TypeGroupSitePublisher";
import TitleBar from "../../../partials/content/TitleBar";
import Pagination from "../../../partials/content/Pagination";

export default function AllCategoryUserSitePublisher({ userID }) {
  const [typeAdvertiseSelect, setTypeAdvertiseSelect] = useState("banner");
  const [tokenCustomer, setTokenCustomer] = useState();
  const [allCategoryUserSitePublisher, setAllCategoryUserSitePublisher] =
    useState([]);
  const [showSelectTagMannerAddGroup, setShowSelectTagMannerAddGroup] =
    useState(false);
  const [linkPageAddGroup, setLinkPageAddGroup] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);
  const [nameCategorySearchFilter, setNameCategorySearchFilter] = useState();

  useEffect(() => {
    getTokenCustomer();
  }, [tokenCustomer]);

  useEffect(() => {
    setTokenCustomer();
  }, [userID]);

  useEffect(() => {
    if (!tokenCustomer) {
      return;
    }

    getAllCategoryUserSitePublisher();
  }, [currentPage, countItemPerPage, nameCategorySearchFilter, tokenCustomer]);

  const getTokenCustomer = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestGetTokenUser = await sendRequestGetTokenUser(userID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultSendRequestGetTokenUser) {
      return;
    }

    setTokenCustomer(resultSendRequestGetTokenUser);
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (nameCategorySearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&name=${nameCategorySearchFilter}`;
    }

    return searchFilterQuery;
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const getHeaderRequestForCustomer = () => {
    const headersRequest = {
      headers: {
        authorization: `Bearer ${tokenCustomer}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestGetTokenUser = async (userID) => {
    let token;
    let headersRequest = getHeaderRequest();
    try {
      token = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/user/enter-users-profile-customer-coworker/" +
          userID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return token.data.data;
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getAllCategoryUserSitePublisher = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestGetAllCategoryUserSitePublisher =
      await sendRequestGetAllCategoryUserSitePublisher(searchFilterQuery);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultSendRequestGetAllCategoryUserSitePublisher) {
      return;
    }
    setAllCategoryUserSitePublisher(
      resultSendRequestGetAllCategoryUserSitePublisher.category_user_site_publishers
    );
    setCountPage(resultSendRequestGetAllCategoryUserSitePublisher.count_page);
  };

  const sendRequestGetAllCategoryUserSitePublisher = async (
    searchFilterQuery
  ) => {
    const headersRequest = getHeaderRequestForCustomer();
    let resultSitePublisherData;
    try {
      resultSitePublisherData = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/category-user-site-publishers-pagination?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return resultSitePublisherData.data.data;
  };

  const showSelectTagTypeAdvertiseGroupPublisher = () => {
    document
      .querySelector("#select-type-advertise-group-publisher")
      .classList.remove("d-none");
    document
      .querySelector("#select-type-advertise-group-publisher select")
      .classList.remove("d-none");
    document
      .querySelector("#btn-add-group-site-publisher")
      .classList.remove("d-none");
  };

  const selectTypeAdvertiseGroupPublisherHandler = (e) => {
    const typeAdvertiseSelect = e.target.value;
    setTypeAdvertiseSelect(typeAdvertiseSelect);
  };

  const generateAllCategoryUserSitePublisherTag = () => {
    return (
      <>
        {showButtonGroup()}
        {/* <div className="py-2">
          <Link
            to={`/publishers/coworker/add-group/banner/${userID}`}
            className="btn btn-success"
          >
            <span class="pl-2">
              <i class="fa fa-plus"></i>
            </span>
            <span>گروه جدید بنری</span>
          </Link>
        </div> */}
        <div class="container-fluid">
          <div class="row border border-1 rounded py-2">
            <div class="col-12 col-md-4">
              <div>
                <label>جستجو در نام گروه نمایش دهنده</label>
              </div>
              <div>
                <input
                  className="form-control"
                  type="text"
                  placeholder="نام گروه نمایش دهنده را در اینجا وارد کنید "
                  onKeyUp={(e) => setNameCategorySearchFilter(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="table-responsive pt-2">
          <table className="table table-hilite tbl-td-white-space  mb-0">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره گروه</td>
                <td>نام</td>
                <td>تاریخ شروع</td>
                <td>تاریخ پایان</td>
                <td>تاریخ درج</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {allCategoryUserSitePublisher.map(
                (categoryUserSitePublisherTag, index) => {
                  return (
                    <tr key={categoryUserSitePublisherTag.id}>
                      <td>{helperNumber.toPersianNum(index + 1)}</td>
                      <td>
                        {helperNumber.toPersianNum(
                          categoryUserSitePublisherTag.id
                        )}
                      </td>
                      <td>{categoryUserSitePublisherTag.name}</td>

                      <td className="number-finance">
                        <span>
                          {helperNumber.toPersianNum(
                            helperTime.convertGregorianToJalali(
                              categoryUserSitePublisherTag.start_date
                            )
                          )}
                        </span>
                        <span className="pl-2">۰۰:۰۰</span>
                      </td>
                      <td className="number-finance">
                        <span>
                          {helperNumber.toPersianNum(
                            helperTime.convertGregorianToJalali(
                              categoryUserSitePublisherTag.end_date
                            )
                          )}
                        </span>
                        <span className="pl-2">۲۳:۵۹</span>
                      </td>
                      <td className="number-finance">
                        {helperNumber.toPersianNum(
                          categoryUserSitePublisherTag.created_at.split(
                            " "
                          )[1] +
                            " " +
                            helperTime.convertGregorianToJalali(
                              categoryUserSitePublisherTag.created_at.split(
                                " "
                              )[0]
                            )
                        )}
                      </td>
                      <td>
                        <div>
                          <span className="pl-2">
                            <Link
                              to={`/publishers/coworker/edit-group/${categoryUserSitePublisherTag.type}/${categoryUserSitePublisherTag.id}/${userID}`}
                              className="btn btn-success  "
                            >
                              <i className="fa fa-edit"></i>
                            </Link>
                          </span>
                        </div>
                      </td>
                    </tr>
                  );
                }
              )}
            </tbody>
          </table>
        </div>
        {countPage > 1 ? generatePagination() : <></>}
      </>
    );
  };

  const generateUserDoseNotHaveCategoryTag = () => {
    return (
      <div class="d-flex flex-column flex-md-row">
        <div class="text-center text-md-right">
          <img
            class="img-fluid"
            src="/assets/img/do-not-have-category-site-publisher.svg"
          />
        </div>
        <div class="d-flex flex-column justify-content-center pr-0 pt-3  pr-md-3 pt-md-0">
          <p>کاربر هیچ گروه نمایش دهنده بنری ندارد :(</p>
          <p>برای شروع کار یک گروه نمایش دهنده بسازید.</p>
          <div>{showButtonGroup()}</div>
        </div>
      </div>
    );
  };

  const showButtonGroup = () => {
    return (
      <div className="d-flex flex-column flex-lg-row pt-2">
        <div className="pb-2 pb-lg-2">
          <div
            className="btn btn-success"
            onClick={() => {
              setShowSelectTagMannerAddGroup(true);
            }}
          >
            <span className="pl-2">
              <i className="fa fa-plus"></i>
            </span>
            <span>
              <span>اضافه کردن گروه جدید</span>
            </span>
          </div>
        </div>
        {showSelectTagMannerAddGroup && (
          <>
            <div className="pb-2 pb-lg-0 pr-lg-2">
              <select
                className="form-control"
                onChange={(e) => {
                  const link = e.target.value;
                  if (!link) {
                    setLinkPageAddGroup(false);
                    return;
                  }
                  setLinkPageAddGroup(link);
                }}
              >
                <option value="">روش ساخت گروه را انتخاب کنید</option>
                <option
                  value={`/publishers/coworker/add-group/banner/${userID}`}
                >
                  دستی
                </option>
                <option
                  value={`/publishers/coworker/add-group-automate/banner/${userID}`}
                >
                  خودکار
                </option>
              </select>
            </div>

            {linkPageAddGroup && (
              <div className="pb-2 pr-lg-2">
                <Link to={linkPageAddGroup} className="btn btn-success">
                  افزودن
                </Link>
              </div>
            )}
          </>
        )}
      </div>
    );
  };

  return (
    <>
      {allCategoryUserSitePublisher.length == 0 &&
      nameCategorySearchFilter == null
        ? generateUserDoseNotHaveCategoryTag()
        : generateAllCategoryUserSitePublisherTag()}
    </>
  );
}
